import { useEffect } from 'react'
import { connect } from 'react-redux'

import { authDirectLogout } from '@cibo/profile'

const Logout = ({ authDirectLogout }) => {
  useEffect(authDirectLogout, [])

  return null
}

export default connect(null, { authDirectLogout })(Logout)
